export function getQueryParam(key: string): string | undefined {
	const matches = decodeURIComponent(location.search).match(
		new RegExp(`${key}=([^&]+)`)
	);
	if (matches !== null) {
		return matches[1];
	}
}
